// This controller is deprecated and replaced by sidebar_dropdown_controller.js
// Keeping file to prevent 404s if referenced in built assets temporarily
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        console.warn("Deprecated workspace_switcher_controller loaded. Use sidebar-dropdown instead.")
    }
}
